import React, { FC, PropsWithChildren, useEffect, useMemo, useState } from 'react';
import API from '../services/API';
import { Abilities } from '@quartermaster/qmlib-api/dist/types/Ability';

export const FeatureFlagContext = React.createContext<Abilities>({});

const FeatureFlagProvider: FC<PropsWithChildren<void>> = ({ children }) => {
  const [featureFlags, setFeatureFlags] = useState<Abilities>({});
  const getFeatureFlags = () => API.Ability().get();

  useEffect(() => {
    getFeatureFlags().then(data => {
      setFeatureFlags(data.data);
    });
  }, []);

  const values = useMemo(() => {
    return {
      ...featureFlags,
    };
  }, [featureFlags]);

  return (
    <FeatureFlagContext.Provider value={values}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

FeatureFlagProvider.displayName = 'FeatureFlagProvider';

export default FeatureFlagProvider;
